
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import SampleCode from '../../../components/docs/plaidoms/SampleCode';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn how to handle invalid Link tokens by catching the error in the onExit callback and re-fetching a new link_token for the next time the user opens Link'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Handling an invalid Link token' subtitle='Catch the error in the onExit callback and refetch a new link_token for the next time the user opens Link' mdxType="Header" />
    <p>{`Occasionally, the end user may invalidate the existing `}<inlineCode parentName="p">{`link_token`}</inlineCode>{` that was used to open Link by taking too long to go through the flow (a `}<inlineCode parentName="p">{`link_token`}</inlineCode>{` expires after 4 hours, or after 30 minutes if it was created for an existing Item in update mode), or attempting too many invalid logins. If this happens, Link will exit with an `}<a parentName="p" {...{
        "href": "/docs/errors/invalid-input#invalid_link_token"
      }}><inlineCode parentName="a">{`INVALID_LINK_TOKEN`}</inlineCode></a>{` error code.`}</p>
    <p>{`To allow your user to open Link again, recognize the error in the `}<inlineCode parentName="p">{`onExit`}</inlineCode>{` callback, fetch a new `}<inlineCode parentName="p">{`link_token`}</inlineCode>{`, and use it to reinitialize Link. You can obtain a new `}<inlineCode parentName="p">{`link_token`}</inlineCode>{` by making another `}<inlineCode parentName="p">{`/link/token/create`}</inlineCode>{` request:`}</p>
    <SampleCode.CreateLinkToken product='auth' />
    <p>{`For the Link web integration, reinitializing Link means creating a new iframe. To avoid stacking iframes for each Link initialization, you can clean up the old iframe by calling the `}<a parentName="p" {...{
        "href": "/docs/link/web#destroy"
      }}><inlineCode parentName="a">{`destroy()`}</inlineCode></a>{` method on the Plaid Link handler.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "switcher=false #Reinitializing Link",
        "switcher": "false",
        "#Reinitializing": true,
        "Link": true
      }}>{`// Initialize Link with a new link_token each time.
const configs = {
  token: (await $.post('/create_link_token')).link_token,
  onSuccess: (public_token, metadata) => {
    // Send the public_token to your app server.
  },
  onExit: async (err, metadata) => {
    // The user exited the Link flow with an INVALID_LINK_TOKEN error.
    // This can happen if the token expires or the user has attempted
    // too many invalid logins.
    if (err != null && err.error_code === 'INVALID_LINK_TOKEN') {
      linkHandler.destroy();
      linkHandler = Plaid.create({
        ...configs,
        // Fetch a new link_token because the old one was invalidated.
        token: (await $.post('/create_link_token')).link_token,
      });
    }
    // metadata contains the most recent API request ID and the
    // Link session ID. Storing this information is helpful
    // for support.
  },
};

let linkHandler = Plaid.create(configs);
`}</code></pre>
    <p>{`When the user is ready, they will be able to reopen Link and go through the authentication process again.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
